import React from 'react'
import {useStaticQuery, graphql} from "gatsby"
import BackgroundImage from 'gatsby-background-image'

const Banner = () => {
    const data = useStaticQuery(graphql`
        query {
            background: file(relativePath: { eq: "Banner/Banner2/background-desktop-anschnitt-ideal.png" }) {
                childImageSharp {
                    fluid(maxWidth: 2000, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `)

    return (
        <div id="banner" className="banner">
            <a href="https://www.th-wildau.de/forschung-transfer/neuigkeiten-und-veranstaltungen/awareness-forum/"  
                                                target="_blank" rel="noreferrer" 
                                                aria-label="Ankündigung Awareness-Forum 2023">
            <BackgroundImage
                Tag="div"
                id="backgroundImage"
                fluid={data.background.childImageSharp.fluid}
                backgroundColor={`#333333`}
            >
                <div className="main-text">
                    {/* <p>Neue Wege für mehr Informations&shy;sicherheit</p> */}
                </div>
            </BackgroundImage>
            </a>
        </div>
    )
}

export default Banner